import { S3 as profileImage } from "const/social-icons";

import SocialCredential from "./base";

const S3 = SocialCredential.extend({
    parse: function (response) {
        response = S3.__super__.parse.apply(this, arguments);

        response.name = response.s3IntegrationName;
        response.typeLabel = `S3`;
        response.platformType = `S3 account`;
        response.profileImage = profileImage;

        return response;
    }
});

export default S3;
